import React, { useEffect, useState } from "react";
import { getRoleAction, getRoleByIdAction, deleteRoleAction } from "../../Actions/RoleActions";
import AddEditRolesModal from "./AddEditRoles";
import CustomSnackbar from "../Common/snackBar";
import {
  getPermissionData,
  getUserData,
} from "../../Actions/common";
import { CircularProgress } from "@mui/material";
import AdminImage from "../../Assets/images/admin-01.svg";
import BreadcrumbsComponent from "../../components/Common/Breadcrumbs";
import { MyAddIcon, MyBorderColorOutlinedIcon, MyDeleteForeverOutlinedIcon, MyRemoveRedEyeOutlinedIcon } from "../../Assets/svg/MyIcons";
import CustomTooltip from "../../Assets/customTheme/customtooltip";
import showConfirmation from "../../utils/Conformation";

const RoleManagerSection = () => {
  const userData = localStorage.getItem("userData") ? getUserData() : null;
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNewRolesModal, setShowNewRolesModal] = useState(false);
  const [showViewRolesModal, setShowViewRolesModal] = useState(false);
  const [roleDataById, setRoleDataById] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const permissionData = localStorage.getItem(`${userData?.id}_permissionData`)
    ? getPermissionData(`${userData?.id}_permissionData`)
    : [];
  const hasPermission = permissionData[0]?.role_permissions?.find(
    (m) => m?.module && m?.module?.slug === "roles"
  );

  const fetchRoles = () => {
    setLoading(true);
    getRoleAction()
      .then((res) => {
        const { data } = res?.data;
        setRoles(data);
        setLoading(false);
      })
      .catch((error) => {
        setSnackbar({
          open: true,
          message: error.response?.data?.message,
          severity: "error",
        });

        setLoading(false);
      });
  };

  useEffect(() => {
    fetchRoles();
    // eslint-disable-next-line
  }, []);

  const handleAddEditRole = async (e, id) => {
    if (id) {
      await getRoleByIdAction(id)
        .then((res) => {
          setRoleDataById(res?.data?.data);
          setShowNewRolesModal(true);
        })
        .catch((error) => {
          setSnackbar({
            open: true,
            message: error.response.data.message,
            severity: "error",
          });
        });
    } else {
      setShowNewRolesModal(true);
    }
  };

  const handleViewRole = async (e, id) => {
    await getRoleByIdAction(id)
      .then((res) => {
        setRoleDataById(res.data?.data);
        setShowViewRolesModal(true);
        setShowNewRolesModal(true);
      })
      .catch((error) => {
        setSnackbar({
          open: true,
          message: error.response.data.message,
          severity: "error",
        });
      });
  };

  const handleCloseModal = () => {
    setShowNewRolesModal(false);
    setShowViewRolesModal(false);
    setRoleDataById(null);
  };

  const mode = roleDataById ? "edit" : "add";

  const handleDelete = async (e, id) => {
    e.stopPropagation();

    await showConfirmation("simpleDelete", {
      entityName: "Role",
      entityId: id,
      action: async (roleId) => {
        const res = await deleteRoleAction(roleId);

        // Handle status 202 case
        if (res?.data?.status === 202) {
          setSnackbar({
            open: true,
            message: res.data.message,
            severity: "info",
          });
        }

        return res;
      },
      onSuccess: (res) => {
        fetchRoles();
      },
      onError: (error) => {
        setSnackbar({
          open: true,
          message: error?.response?.data?.message || "Something went wrong",
          severity: "error",
        });
      },
      showCancelledMsg: true,
    });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <div id="kt_content_container">
      <BreadcrumbsComponent />
      <div className="row">
        <div className="col-12 ">
          <div className="d-flex align-items-start">
            <div className="toolbar p-0 shadow-none position-static border-top-0 px-0 bg-transparent w-100">
              <div className="container-fluid d-flex align-items-center px-0">
                {hasPermission?.canCreate && (
                  <div className="d-flex align-items-center flex-wrap ms-auto">
                    <button
                      className="btn btn-primary"
                      title="Add Role"
                      onClick={(e) => handleAddEditRole(e)}
                      style={{
                        // border: "none",
                        // background: "none",
                        // padding: 0,
                        marginBottom: 5,
                      }}
                    >
                      <MyAddIcon className="text-white" /> Add Role
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "50vh",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          <div className="row row-cols-1 row-cols-md-2 row-cols-xl-4 row-cols-xxl-5 g-5 g-xl-9">
            {roles &&
              roles.map((item, index) => (
                <div className="col-md-4" key={index}>
                  <div className="card card-flush h-md-100">
                    <div className="card-body  position-relative">
                      <div className="d-flex flex-column position-absolute top-0 end-0">
                        {hasPermission?.canEdit &&
                          item?.id?.toString() !==
                          userData?.roleId?.toString() && (
                                    <CustomTooltip title="Edit" placement="right" arrow>
                            <div
                              className="btn  btn-light border-primary border text-primary my-1 top-0 mt-4 me-5 end-0 btn-icon d-flex align-items-center justify-content-center"
                              data-bs-toggle="modal"
                              data-bs-target="#kt_modal_update_role_accout_form"
                            >
                              <MyBorderColorOutlinedIcon
                                onClick={(e, params) =>
                                  handleAddEditRole(e, item.id)
                                }
                              />
                            </div>
                          </CustomTooltip>
                          )}
                        {hasPermission?.canDelete &&
                          item.id !== userData?.roleId && (
                            <CustomTooltip title="Delete" placement="right" arrow>
                              <div
                                className="btn btn-icon border-danger border btn-light-danger my-1 p-3 top-0 mt-4 me-5 end-0"
                                onClick={(e) => handleDelete(e, item.id)}
                              >
                                <MyDeleteForeverOutlinedIcon />
                              </div>
                            </CustomTooltip>
                          )}
                        {hasPermission?.canView && (
                                <CustomTooltip title="View" placement="right" arrow>
                          <div
                            className="btn btn-icon  border-primary border btn-light-primary my-1 top-0 mt-4 me-5 end-0 d-flex align-items-center justify-content-center"
                            data-bs-toggle="modal"
                            data-bs-target="#kt_modal_update_role_accout_form"
                          >
                            <MyRemoveRedEyeOutlinedIcon
                              onClick={(e, params) =>
                                handleViewRole(e, item.id)
                              }
                            />
                          </div>
                          </CustomTooltip>
                        )}
                      </div>
                      <div className="d-flex flex-column">
                        <span className="d-flex flex-column flex-center pt-md-15 pt-lg-5">
                          <img
                            src={AdminImage}
                            alt=""
                            className="mw-100 mh-100px mb-4"
                          />
                        </span>
                      </div>
                      <div className="card-title d-flex justify-content-center m-0">
                        <h2 className="fw-medium mb-0">{item.roleName}</h2>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
          {
            showNewRolesModal ? (
              <AddEditRolesModal
                open={showNewRolesModal}
                handleClose={handleCloseModal}
                roleDataById={roleDataById}
                setSnackbar={setSnackbar}
                mode={mode}
                showViewRolesModal={showViewRolesModal}
                fetchRoles={fetchRoles}
                userData={userData}
              />
            ) : null
          }
          < CustomSnackbar
            open={snackbar.open}
            message={snackbar.message}
            severity={snackbar.severity}
            onClose={handleCloseSnackbar}
          />
        </>
      )}
    </div>
  );
};

export default RoleManagerSection;
